import { useEffect, useMemo, useState } from 'react';
import { useSearchParams, useLocation } from 'react-router-dom';

// ----------------------------------------------------------------------

export const ORDERING_SECTIONS = {
  LOCATIONS: 'locations',
  BRANDS: 'brands',
  CATEGORIES: 'categories',
};

export function computeActiveSection({ locationQuery, brandsCount, brandIdParam }) {
  if (locationQuery) {
    return ORDERING_SECTIONS.LOCATIONS;
  }
  if (!locationQuery && brandsCount > 0 && !brandIdParam) {
    return ORDERING_SECTIONS.BRANDS;
  }
  if (
    (!locationQuery && brandsCount > 0 && brandIdParam) ||
    (!locationQuery && brandsCount <= 0)
  ) {
    return ORDERING_SECTIONS.CATEGORIES;
  }
  return '';
}

/**
 * Syncs URL search params → API query string for useGetProducts.
 */
export function useProductListingPath(options = {}) {
  const { defaultCustomerId = '38', skipDefaultWhenCheckout = true } = options;
  const [searchParams, setSearchParams] = useSearchParams();
  const { pathname } = useLocation();
  const [path, setPath] = useState('');

  useEffect(() => {
    const _locationId = searchParams.get('location_id');
    const _customerId = searchParams.get('customer_id');
    const _brandId = searchParams.get('brand_id');
    if (_customerId) {
      setPath(`?customer_id=${_customerId}`);
    }
    if (_locationId) {
      setPath(`?location_id=${_locationId}`);
      if (_brandId) {
        setPath(`?location_id=${_locationId}&brand_id=${_brandId}`);
      }
    }
    const onCheckout = pathname.includes('checkout');
    if (!_customerId && !_locationId && !(skipDefaultWhenCheckout && onCheckout)) {
      setSearchParams(`customer_id=${defaultCustomerId}`);
      setPath(`?customer_id=${defaultCustomerId}`);
    }
  }, [searchParams, setSearchParams, pathname, defaultCustomerId, skipDefaultWhenCheckout]);

  return { path, searchParams, setSearchParams, pathname };
}

export function useOrderingActiveSection(locationQuery, brands, searchParams) {
  return useMemo(
    () =>
      computeActiveSection({
        locationQuery,
        brandsCount: brands?.length ?? 0,
        brandIdParam: searchParams?.get('brand_id'),
      }),
    [locationQuery, brands?.length, searchParams]
  );
}
